import React, { Component } from "react";
import './Checkbox.scss';

class Checkbox extends Component {
  render() {
    let {
      value,
      label,
      name,
      onClick,
      baseClassname = "",
      style = {},
      setRef = () => ({}),
      disabled,
      theme = "default",
      ...props
    } = this.props;
    name = name ? name : label;
    return (
      <div
        className={`control control-checkbox control-checkbox--${theme} ${baseClassname}`}
        // To prevent calling onClick twice (due to click on <label> and <input> bubbling up)
        // Check if the event target has type checkbox, i.e. label indirectly clicks on checkbox
        onClick={evt => {
          evt.preventDefault();
          evt.stopPropagation();
          // if (evt.target["title"] === "checkbox") {
          //   this.refs["checkbox"].click();
          // }
          // return evt["target"]["type"] === "checkbox" ? onClick(evt) : null;
          return onClick && !disabled? onClick(evt) : null;
        }}
        style={style}
      >
        <input
          type="checkbox"
          name={name}
          id={name}
          disabled={disabled}
          // ref="checkbox"
          // value={true}
          checked={value}
          ref={setRef}
          style={{ backgroundColor: "transparent" }}
          onChange={() => null}
          {...props}
        />
        <div className="control_indicator" />
        <label className={`${disabled && "control_indicator_disabled"}`} htmlFor={name}>{label}</label>
      </div>
    );
  }
}

export default Checkbox;
